import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { DecorativeText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsIngredientTitle = (props: Props) => {
  const { children } = props;

  return (
    <DecorativeText sizeMatch={['24']} italic style={styles.title}>
      {children}
    </DecorativeText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
